import { createStore } from 'vuex'

export const dataFighters = createStore({
  state: () => {
    return {
      id: null,
      name: undefined,
      cpf: undefined,
      email: undefined,
      role: null,
      password: {
        old: undefined,
        newPass: undefined,
        confirm: undefined
      },
      image: undefined,
      imgPath: undefined,
      importUsers: [],
      importFileName: undefined,
      importErrors: [],
      // amount: undefined,
      // percent: undefined,

      myEvents: [],
      fighters: [],
      events: [],
      nextAndAllEvents: [],

      page: {
        title: 'Turmas',
        subtitle: 'Gerencie suas turmas'
      }
    }
  },
  getters: {
    getPermissionType: (state) => state.permission_type,
    getFighters: (state) => state.fighters,
    getEvents: (state) => state.events,
    getMyEvents: (state) => state.myEvents,
    getCollectionByFilter: (state) => state.nextAndAllEvents,
    getImportUsers: (state) => state.importUsers,
    getImportFileName: (state) => state.importFileName,

    // pages
    getPageConf: (s) => s.page

  },
  mutations: {
    reset (state) {
      state.id = null
      state.name = undefined
      state.cpf = undefined
      state.email = undefined
      state.role = null
      state.amount = undefined
      state.percent = undefined
      state.myEvents = []
      state.events = []
      state.image = undefined
      state.imgPath = undefined
      state.importUsers = []
      state.importFileName = undefined
      state.importErrors = []
      state.password.old = null
      state.password.newPass = null
      state.password.confirm = null
    },
    updateCollabFields (state, payload) {
      Object.assign(state, payload)
      state.myEvents = payload.coupon
      state.image = payload.avatar
      state.imgPath = payload.avatar
    },
    setCollabSettings (state, payload) {
      // state.turno = payload
    },
    SET_FIGHTERS_COLLECT (state, payload) {
      state.fighters = []
      state.fighters = payload
    },
    SET_EVENTS_COMBO (state, payload) {
      state.events = []
      state.events = payload
    },
    SET_COLLECT_VALUE (state, value) {
      state.myEvents = value
    },
    REMOVE_ITEM_BY_COLLECT_VALUE (state, value) {
      state.myEvents.splice(value, 1)
    },
    SET_MY_EVENTS (state, events) {
      state.nextAndAllEvents = events
    },
    SET_PAGE_CONF (state, value) {
      state.page.title = value?.title
      state.page.subtitle = value?.subtitle
    },
    SET_IMPORT_USERS (state, value) {
      state.importUsers = value
    },
    SET_IMPORT_FILE_NAME (state, value) {
      state.importFileName = value
    },
    SET_IMPORT_ERRORS (state, value) {
      state.importErrors = value
    },
    CLEAR_IMPORT_DATA (state) {
      state.importUsers = []
      state.importFileName = undefined
      state.importErrors = []
    }
  },
  actions: {
    setCollabSettings ({ commit }, value) {
      commit('setCollabSettings', value)
    },
    setFightersCollect ({ commit }, value) {
      commit('SET_FIGHTERS_COLLECT', value)
    },
    setComboEvents ({ commit }, value) {
      commit('SET_EVENTS_COMBO', value)
    },
    setCollectValue ({ commit }, val) {
      commit('SET_COLLECT_VALUE', val)
    },
    removeItemByCollectValue ({ commit }, val) {
      commit('REMOVE_ITEM_BY_COLLECT_VALUE', val)
    },
    difineConfigsForPage ({ commit }, val) {
      commit('SET_PAGE_CONF', val)
    },
    setImportUsers ({ commit }, val) {
      commit('SET_IMPORT_USERS', val)
    },
    setImportFileName ({ commit }, val) {
      commit('SET_IMPORT_FILE_NAME', val)
    },
    clearImportData ({ commit }) {
      commit('CLEAR_IMPORT_DATA')
    }
  }
})
